var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.statusColor
    ? _c("div", { staticClass: "legend-item" }, [
        _c(
          "span",
          {
            class: [
              { "legend-item__circle--with-text": _vm.hasStatusLabel },
              { "legend-item__circle--clickable": _vm.clickable },
              ,
              "legend-item__circle",
            ],
            style: {
              "background-color": _vm.statusColor,
            },
            on: { click: _vm.legendClicked },
          },
          [
            _c("span", { staticClass: "legend-item__circle__text" }, [
              _vm._v(" " + _vm._s(_vm.statusLabel) + " "),
            ]),
          ]
        ),
        _vm.hasLabel
          ? _c(
              "span",
              {
                class: [
                  {
                    "legend-item__label--with-status-label": _vm.hasStatusLabel,
                  },
                  "legend-item__label",
                ],
                style: {
                  color: _vm.labelColor,
                  "font-size": _vm.labelFontSize,
                },
              },
              [_vm._v(" " + _vm._s(_vm.label) + " ")]
            )
          : _vm._e(),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }